import { render, staticRenderFns } from "./AppealReviewPage.vue?vue&type=template&id=532205ea&scoped=true"
import script from "./AppealReviewPage.vue?vue&type=script&lang=js"
export * from "./AppealReviewPage.vue?vue&type=script&lang=js"
import style0 from "./AppealReviewPage.vue?vue&type=style&index=0&id=532205ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532205ea",
  null
  
)

export default component.exports